module.exports = __webpack_public_path__ + "static/media/fire.8903a468.jpg";